interface ConversionStepProps {
  onExplore: () => void;
}

const FEATURES = [
  { icon: "ri-cloud-upload-line", text: "클립 무제한 저장 및 관리", color: "#00D9FF" },
  { icon: "ri-send-plane-line", text: "TikTok · YouTube Shorts · Reels 즉시 배포", color: "#10B981" },
  { icon: "ri-bar-chart-2-line", text: "채널별 성과 분석 대시보드", color: "#F59E0B" },
  { icon: "ri-history-line", text: "AI 모델 지속 학습 및 품질 개선", color: "#A78BFA" },
];

export default function ConversionStep({ onExplore }: ConversionStepProps) {
  return (
    <div className="w-full max-w-2xl mx-auto text-center">
      {/* Success icon */}
      <div className="relative inline-flex items-center justify-center mb-8">
        <div className="w-24 h-24 rounded-full bg-[#10B981]/10 border-2 border-[#10B981]/30 flex items-center justify-center">
          <i className="ri-sparkling-2-line text-4xl text-[#10B981]" />
        </div>
        <div className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-[#10B981] flex items-center justify-center">
          <i className="ri-check-line text-white text-sm" />
        </div>
      </div>

      <div className="mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          결과물을 저장하고
          <br />
          <span className="text-[#00D9FF]">즉시 배포</span>해보세요
        </h2>
        <p className="text-gray-400 text-base leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          무료 계정을 만들면 생성한 클립을 저장하고
          <br />
          TikTok, YouTube Shorts, Instagram Reels에 바로 게시할 수 있습니다
        </p>
      </div>

      {/* Feature list */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-left">
        {FEATURES.map((f) => (
          <div key={f.text} className="flex items-center gap-3 bg-[#0F1419] border border-white/8 rounded-xl px-4 py-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0" style={{ background: `${f.color}18` }}>
              <i className={`${f.icon} text-sm`} style={{ color: f.color }} />
            </div>
            <span className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{f.text}</span>
          </div>
        ))}
      </div>

      {/* CTAs */}
      <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
        <button
          className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-[#00D9FF] hover:bg-[#00D9FF]/90 text-[#0A0E14] font-bold text-base px-8 py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-user-add-line" /></span>
          무료 계정 만들기
        </button>
        <button
          onClick={onExplore}
          className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-white/6 hover:bg-white/10 text-white font-semibold text-base px-8 py-4 rounded-xl border border-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-compass-3-line" /></span>
          계속 탐색하기
        </button>
      </div>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-5 text-xs text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>
        {["신용카드 불필요", "14일 무료 체험", "언제든지 취소"].map((text) => (
          <span key={text} className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-[#10B981]" />
            {text}
          </span>
        ))}
      </div>

      {/* Stats */}
      <div className="mt-10 pt-8 border-t border-white/6 grid grid-cols-3 gap-4">
        {[
          { value: "2.8M+", label: "생성된 클립", color: "#00D9FF" },
          { value: "428M", label: "누적 조회수", color: "#10B981" },
          { value: "98%", label: "고객 만족도", color: "#F59E0B" },
        ].map((stat) => (
          <div key={stat.label}>
            <div className="text-2xl font-bold mb-0.5" style={{ fontFamily: "'JetBrains Mono', monospace", color: stat.color }}>{stat.value}</div>
            <div className="text-gray-500 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
